import styled, { css } from 'styled-components'
import { theme } from 'constants/theme'

const DateControl = styled.div`
  position: relative;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 0;
  justify-content: flex-start;
  width: max-content;
  height: 92px;
  flex-shrink: 0;

  & div.react-bootstrap-daterangepicker-container {
    z-index: 2;
  }
`

const Frequency = styled.div`
  text-align: right;
  margin-top: 16px;
  width: max-content;
`

const FrequencyButtons = styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 10px;

  & > span {
    display: flex;
  }
`

const FrequencyButton = styled.button<{
  isSelected: boolean
  $isCustomTab?: boolean
  $isCustomSelected?: boolean
}>`
  background: ${({ isSelected }) => (isSelected ? 'var(--color-button-secondary)' :
    theme.tabs.dateButton.color)};
  border: 1px solid ${({ isSelected }) => (isSelected ? 'var(--color-button-secondary)' :
    theme.tabs.dateButton.border)};
  box-sizing: border-box;
  color: ${({ isSelected }) => (isSelected ? 'var(--color-text-on-secondary)' :
    theme.tabs.dateButton.text())};
  padding: ${({ $isCustomSelected }) => ($isCustomSelected ? '14px 12px' : '14px 18px')};
  text-align: center;
  font-size: 14px;
  line-height: 1;
  outline: none !important;
  cursor: pointer;
  white-space: nowrap;

  ${({ $isCustomTab }) => $isCustomTab && css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
  `}

  &:not(:first-of-type) {
    border-left: none;
  }

  &:first-of-type {
    border-radius: 10px 0 0 10px;
  }

  &:last-of-type {
    border-radius: 0 10px 10px 0;
  }
`

const CustomButtonContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`

const CustomDateRangeWrap = styled.div`
  position: absolute;
  right: 0;
  top: 77px;
  width: fit-content;
  margin: 0;

  & > div {
    width: auto !important;
    max-width: none !important;
    margin-left: 0 !important;
  }

  input {
    width: 158px !important;
    height: 32px !important;
    margin: 0 !important;
    font-size: 12px;
    padding: 0 8px;
    box-sizing: border-box;
    border-radius: 10px;
    border: 1px solid var(--color-issabeline-grey);
    background: var(--color-background-primary, #fff);
    color: ${theme.tabs.dateButton.text()};
    cursor: pointer;
    text-align: center;
  }
`

export {
  DateControl,
  Frequency,
  FrequencyButtons,
  FrequencyButton,
  CustomButtonContent,
  CustomDateRangeWrap,
}
